module.exports = __webpack_public_path__ + "static/img/11.774c0bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/11.png
// module id = I9ka
// module chunks = 0